import React from "react";
import { Link } from "@quintype/components";

import FacebookIcon from "../FooterIcons/FacebookIcon";
import TwitterIcon from "../FooterIcons/TwitterIcon";
import Instagram from "../../../atoms/icons/Instagram";
import YoutubeIcon from "../FooterIcons/YoutubeIcon";

import { getSocialLinks } from "../../../utils/utils";

import "./bondhushavaFooter.m.css";

const BondhushavaFooter = () => {
  const socialLinks = getSocialLinks("bondhushava");

  return (
    <div styleName="bondhushava-footer">
      <div styleName="address">
        <span className="line-1">বন্ধুসভা কক্ষ, ঢাকা ট্রেড সেন্টার (৩য় তলা), ৯৯ কাজী </span>
        <span className="line-2">নজরুল ইসলাম অ্যাভিনিউ, কারওয়ান বাজার </span>
        <span className="line-3">ঢাকা-১২১৫ </span>
        <span className="line-4">ফোন: ৮১১০০৮১ , ৮১১৫৩০৭-১০, (১৫২০, ১৫২১) </span>
        <span className="line-5">মোবাইল: ০১৯৫৫৫৫২০৮৮</span>
        <span className="line-6">
          ইমেইল: <a href="mailto:bondhushava@prothomalo.com">bondhushava@prothomalo.com</a>
        </span>
      </div>
      <div styleName="social-links">
        <Link href={socialLinks.fbUrl}>
          <FacebookIcon color="#26afe8" />
        </Link>
        <Link href={socialLinks.twitterUrl}>
          <TwitterIcon color="#26afe8" />
        </Link>
        <Link href={socialLinks.InstagramUrl}>
          <Instagram color="#26afe8" />
        </Link>
        <Link href={socialLinks.YouTubeUrl} className="youtube-icon">
          <YoutubeIcon color="#26afe8" />
        </Link>
      </div>
      <span styleName="copyright">© স্বত্ব বন্ধুসভা ১৯৯৮ – ২০১৯</span>
    </div>
  );
};

export default BondhushavaFooter;
